<ng-container *ngIf="model$ | async; let model" >
  <app-hero-section [model]="model[0]" [photos]="photos"></app-hero-section>
  <div class="container pt-10"  >
    <div class="xl:flex flex-row rfs:gap-[4.5rem]">
      <div class="xl:max-w-[calc(100%_-_283px_-_4.5rem)] relative">
        <app-top-navigation [inputData]="sidePanelData"></app-top-navigation>
        <app-property-description scroll-anchor="paragraph" [model]="model[0]"></app-property-description>
        <app-detail-section scroll-anchor="detail" [model]="model[0]"></app-detail-section>
        @if (model[0].auctionRounds && model[0].auctionRounds.rounds && model[0].auctionRounds.rounds.length > 0) {
          <app-auction-section scroll-anchor="auction" [model]="model[0]"></app-auction-section>
        }
        <app-features-section scroll-anchor="features" [model]="model[0]"></app-features-section>
        <app-map-area-section scroll-anchor="mapArea" [lat]="model[0]?.address?.geoPoint?.split(',')?.at(0)"
          [lon]="model[0]?.address?.geoPoint?.split(',')?.at(1)" [propertyID]="model[0].id"></app-map-area-section>
        @if (floorPlans && floorPlans.length > 0) {
        <app-floor-plan-section scroll-anchor="floorPlan" [address]="model[0].address?.streetName"
          [plotArea]="model[0]?.plotArea" [numOfRooms]="model[0].numberOfRooms" [propertyId]="propertyId"
          [floorPlans]="floorPlans"></app-floor-plan-section>
        }
        <section scroll-anchor="insights">
          <app-property-insights-component [PropertyId]="model[0].id"></app-property-insights-component>
        </section>
        <app-property-services 
          [isSold]="model[0].isSold ?? false"
          [isAuctioned]="!!(model[0].auctionRounds && model[0].auctionRounds.rounds && model[0].auctionRounds.rounds.length > 0)" 
          [propertyCode]="propertyCode" 
          scroll-anchor="services"/>
        <app-costs scroll-anchor="fees" [propertyValue]="model[0].price || 0" [isAuctioned]="!!(model[0].auctionRounds && model[0].auctionRounds.rounds && model[0].auctionRounds.rounds.length > 0)"></app-costs>
        <app-financing-section 
          [isAuctioned]="!!(model[0].auctionRounds && model[0].auctionRounds.rounds && model[0].auctionRounds.rounds.length > 0)" 
          [propertyValue]="model[0].price ?? 0" 
          [isLoggedIn]="isLoggedIn$ | async"
          scroll-anchor="financing"/>
        <div class="pb-20 pt-10"
          *ngIf="similarProperties && similarProperties.items?.length && similarProperties.items!.length > 0">
          <app-similar-properties [similarProperties]="similarProperties" [newWindow]="true"></app-similar-properties>
        </div>
      </div>

      <app-aside-content *ngIf="!model[0].isSold" [property]="model[0]"></app-aside-content>
      <div *ngIf="model[0].isSold"
       class="flex flex-col bg-white xl:relative fixed gap-4 bottom-0 right-0 left-0 xl:rounded-b-medium rounded-t-medium p-6 shadow-[0px_3px_24px_0px_#0000000A] xl:max-w-[283px] h-fit">
        <h3 *transloco="let t; prefix: 'property-details.aside'" class="text-black font-semibold rfs:text-2xl xl:mb-8 flex flex-row items-center justify-between"> {{
          t("sold.aside-title") }} <button (click)="toggleAside()" type="button" class="text-primary-600 xl:hidden">
            <i [ngClass]="{
                'icon-chevron-down': !isOpen,
                'icon-chevron-up': isOpen,
              }"></i>
          </button>
        </h3>
      <div class="flex flex-col xl:flex hidden gap-4">
        <app-experts-callback  [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
      </div>
      <div [ngClass]="{ 'h-0': !isOpen, 'h-[auto]': isOpen }" class="xl:hidden block overflow-hidden">
          <app-experts-callback *ngIf="model[0].isSold" [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
      </div>
    </div>
    </div>
  </div>
</ng-container>